import { z } from "zod";
import { TaskSchema, TaskStatus } from "@common/types/task";
import { zQueryUuidArray } from "@common/schemas/query-uuid-array.schema";
import {
    TaskListQuerySchema,
    TaskThreadUnreadCountSchema,
} from "@common/schemas/task.schema";

export const OrganizationTasksQuerySchema = z.object({
    organizationId: z.string().uuid(),
});

export type OrganizationTasksQuery = z.infer<
    typeof OrganizationTasksQuerySchema
>;

/** The workspace Tasks list filters, applied across the organization's clients. */
export const OrganizationTaskListQuerySchema = TaskListQuerySchema.merge(
    OrganizationTasksQuerySchema,
);

export const OrganizationTaskListResponseSchema = z.object({
    tasks: z.array(TaskSchema),
});

export const OrganizationTaskThreadUnreadCountsResponseSchema = z.object({
    counts: z.array(TaskThreadUnreadCountSchema),
});

export const CLIENT_TASK_PREVIEWS_MAX_WORKSPACES = 10;

export const ClientTaskPreviewsQuerySchema =
    OrganizationTasksQuerySchema.extend({
        workspaceIds: zQueryUuidArray().pipe(
            z
                .array(z.string().uuid())
                .min(1)
                .max(CLIENT_TASK_PREVIEWS_MAX_WORKSPACES),
        ),
    });

export type ClientTaskPreviewsQuery = z.infer<
    typeof ClientTaskPreviewsQuerySchema
>;

export const ClientTaskPreviewSchema = z.object({
    id: z.string().uuid(),
    title: z.string(),
    status: z.union([
        z.literal(TaskStatus.TODO),
        z.literal(TaskStatus.IN_PROGRESS),
    ]),
    hasUnreadChat: z.boolean(),
    lastActivityAt: z.string().datetime(),
});

export type ClientTaskPreview = z.infer<typeof ClientTaskPreviewSchema>;

export const ClientTaskPreviewsSchema = z.object({
    workspaceId: z.string().uuid(),
    tasks: z.array(ClientTaskPreviewSchema),
});

export type ClientTaskPreviews = z.infer<typeof ClientTaskPreviewsSchema>;

export const ClientTaskPreviewsResponseSchema = z.object({
    clients: z.array(ClientTaskPreviewsSchema),
});

export type ClientTaskPreviewsResponse = z.infer<
    typeof ClientTaskPreviewsResponseSchema
>;
